"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Heading3;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Heading3(_ref) {
  var subtitle = _ref.subtitle,
      title = _ref.title,
      description = _ref.description,
      color = _ref.color,
      alignment = _ref.alignment,
      whiteContent = _ref.whiteContent;
  var colors = {
    light: "text-blueGray-200",
    dark: "text-blueGray-800",
    blueGray: "text-blueGray-500",
    red: "text-red-500",
    orange: "text-orange-500",
    amber: "text-amber-500",
    emerald: "text-emerald-500",
    teal: "text-teal-500",
    lightBlue: "text-lightBlue-500",
    indigo: "text-indigo-500",
    purple: "text-purple-500",
    pink: "text-pink-500"
  };
  var alignmentsRow = {
    left: "justify-start",
    center: "justify-center",
    right: "justify-end"
  };
  var alignmentsText = {
    left: "text-left",
    center: "text-center",
    right: "text-right"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-12 flex flex-wrap -mx-4 " + alignmentsRow[alignment]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "px-4 relative w-full lg:w-8/12 " + alignmentsText[alignment]
  }, subtitle && /*#__PURE__*/_react.default.createElement("h6", {
    className: "mb-2 font-bold uppercase " + colors[color]
  }, subtitle), title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-3xl font-bold mt-3 mb-1 " + (whiteContent ? "text-white" : "text-blueGray-700")
  }, title), description && /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-2 mb-4 text-xl leading-relaxed " + (whiteContent ? "text-white opacity-75" : "text-blueGray-400")
  }, description))));
}

Heading3.defaultProps = {
  color: "blueGray",
  alignment: "left",
  whiteContent: false
};
Heading3.propTypes = {
  // use this to make the title and description
  // change colors from blueGray-800 and blueGray-500
  // to white and blueGray-100
  whiteContent: _propTypes.default.bool,
  subtitle: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  alignment: _propTypes.default.oneOf(["left", "center", "right"]),
  // this is the color to be added to the subtitle
  color: _propTypes.default.oneOf(["light", "dark", "blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"])
};
